var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('p',{staticClass:"mzsm"},[_vm._v("本站中的网页作品模板尽可供个人网页学习、网页制作参考使用。您在本站获取的一切资源请勿商业使用。")]),_c('div',{staticClass:"flex"},[_c('p',[_vm._v("联系Q V:1292179368")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("冀ICP备2024093245号-1")])])])
}]

export { render, staticRenderFns }